module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921061151_T.7db0a278.jpg";